module.exports = __webpack_public_path__ + "assets/924178c7.svg";